/**
 * In this file constants used to identify macro-parts of the app for rxjs are declared
 */
export const POSE_A = "POSE";
export const DATA_A = "DATA";
export const NAV_A = "NAV_A";
